// Components
import { Error, Layout } from '@tracklib/kit'
import { YourLibraryHeader } from 'kit'
import CoverGrid from 'components/covergrid'
import Filter from 'components/filter'
import SEO from 'components/base/seo'
import TrackList from 'components/browse/tracklist'

// Hooks
import { useSearchQuery } from 'modules/browse/hooks'
import { useCollection, useFavoritesCollectionId } from 'modules/collections/hooks'

//  Utils
import { isBrowser } from '@process'

const Favorites = () => {
  const title = 'Favorites'
  const description = 'A collection of your favorited tracks and loops.'
  const id = useFavoritesCollectionId()

  const { collection, request: fetchCollectionRequest } = useCollection(id)
  const queryObj = { collection: String(id), limit: 10000 }
  // NOTE(Kitti): Following line disabled to remove loadMore from trackListProps as it isnt used on collection page
  const { trackIds, loadMore, ...songListProps } = useSearchQuery(queryObj, collection?.tracks?.length) // eslint-disable-line
  const tracks = collection?.tracks.filter(track => trackIds.some(({ id: i }) => i === track.id))
  return (
    <>
      <SEO title={title} description={description} />
      <YourLibraryHeader title={title} description={description} image={<CoverGrid mask="star" trackIds={trackIds} />} />
      <Layout.FullWidth>
        <Filter queryObj={queryObj} />
        {!collection && fetchCollectionRequest?.isDone && isBrowser ? (
          <Error message="Favorites couldn't be found" />
        ) : (
          <TrackList renderSpecificTrackNames {...songListProps} totalTrackCount={tracks?.length || 0} trackIds={tracks} />
        )}
      </Layout.FullWidth>
    </>
  )
}

export default Favorites
